import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import Spinner from "react-bootstrap/Spinner";
import Alert from "react-bootstrap/Alert";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import { useAuth } from "react-oidc-context";
import { GetQAResults } from "../services/ApiService";

const QAResultUI = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const auth = useAuth();
  const [showError, setShowError] = useState(false);
  const [selectedIO, setSelectedIO] = useState(null);
  const [campaignIOs, setCampaignIOs] = useState([]);

  const columns = [
    { key: "agency", title: "Agency" },
    { key: "check_type", title: "Check Type" },
    { key: "entity_type", title: "Entity Type" },
    { key: "id_name", title: "ID Name" },
    { key: "io_number", title: "IO Number" },
    { key: "message", title: "Message" },
  ];

  const options = campaignIOs.map((campaign_io) => ({
    label: campaign_io,
    value: campaign_io,
  }));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const raw_data = await GetQAResults(auth.user.id_token);
        const campaignIOs = [...new Set(raw_data.map((adv) => adv.io_number))];
        setCampaignIOs(campaignIOs);
        setData(raw_data);
        setLoading(false);
      } catch (err) {
        console.log(err.message);
        setError("Failed to retrieve the onboarded campaigns");
        setLoading(false);
        setShowError(true);
      }
    };
    fetchData();
  }, [auth.user.id_token]);

  const filteredData = selectedIO
    ? data.filter((item) => item.io_number === selectedIO.value)
    : data;

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <div className="table-container">
      {showError && (
        <Alert variant="danger" onClose={() => setShowError(false)} dismissible>
          <Alert.Heading>Error!</Alert.Heading>
          <p>{error}</p>
        </Alert>
      )}
      <Form.Group className="mb-3">
        <Form.Label>Campaign IO</Form.Label>
        <Select
          isClearable
          isSearchable
          value={selectedIO}
          onChange={setSelectedIO}
          options={options}
          placeholder="Select an IO Number"
        />
      </Form.Group>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key}>{col.title}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {filteredData.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="text-center">
                No data available
              </td>
            </tr>
          ) : (
            filteredData.map((row, idx) => (
              <tr key={idx}>
                {columns.map((col) => (
                  <td key={col.key}>{row[col.key]}</td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default QAResultUI;
